import { Controller } from "@hotwired/stimulus"

// Lets the admin reuse a previous email's subject + formatted body when
// composing a new send. Recipients are left untouched.
export default class extends Controller {
  static targets = ["subjectInput", "editor", "item", "search"]

  filter() {
    const query = this.searchTarget.value.toLowerCase()
    this.itemTargets.forEach((item) => {
      item.classList.toggle("hidden", !item.textContent.toLowerCase().includes(query))
    })
  }

  load(event) {
    const button = event.currentTarget
    const template = button.closest("[data-copy-previous-item]").querySelector("template")

    this.subjectInputTarget.value = button.dataset.subject
    this.editorTarget.editor.loadHTML(template.innerHTML)
  }
}
